var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_1834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2422 20.5078C44.3438 21.6094 44.3438 23.3906 43.2422 24.4805L28.2422 39.4922C27.1406 40.5937 25.3594 40.5937 24.2695 39.4922L16.7695 31.9922C15.668 30.8906 15.668 29.1094 16.7695 28.0195C17.8711 26.9297 19.6523 26.918 20.7422 28.0195L26.25 33.5273L39.2578 20.5078C40.3594 19.4063 42.1406 19.4063 43.2305 20.5078H43.2422Z",
    fill: "#5B5E65"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60ZM43.2422 24.4922L28.2422 39.4922C27.1406 40.5938 25.3594 40.5938 24.2695 39.4922L16.7695 31.9922C15.668 30.8906 15.668 29.1094 16.7695 28.0195C17.8711 26.9297 19.6523 26.918 20.7422 28.0195L26.25 33.5273L39.2578 20.5078C40.3594 19.4062 42.1406 19.4062 43.2305 20.5078C44.3203 21.6094 44.332 23.3906 43.2305 24.4805L43.2422 24.4922Z",
    fill: "#5B5E65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_1834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0b3117655054c43fb37c2c47b4fc9253.svg";
export { ForwardRef as ReactComponent };